<script setup lang="ts">
import { inject, onMounted, onUnmounted, reactive } from 'vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { WindowTool } from '@/components/common/window/WindowInterface';
import { request } from '@/util/request';
import { message } from 'ant-design-vue';

const data = reactive({
  loading: false,
  status: false,
  code: '',
  time: 0,
  end: 0,
});

onMounted(async () => {
  data.loading = true;
  const res = await request('/management/device/getCode');
  if (res) {
    if (res.code) {
      data.status = true;
      data.code = res.code;
      data.end = Date.now() + res.time;
      computeTime()
    }
  }
  data.loading = false;
});

function formatTime(ms: number) {
  const seconds = Math.floor(ms / 1000);
  const hours = Math.floor(seconds / 3600); // 获取小时
  const minutes = Math.floor((seconds % 3600) / 60); // 获取分钟
  const remainingSeconds = seconds % 60; // 获取剩余的秒数
  if (hours > 0) return `${hours}小时${minutes}分钟${remainingSeconds}秒`;
  if (minutes > 0) return `${minutes}分钟${remainingSeconds}秒`;
  if (remainingSeconds > 0) return `${remainingSeconds}秒`;
  return '0';
}

let countdown: number | undefined;

function computeTime() {
  data.time = data.end - Date.now();
  if (data.time <= 0) {
    data.status = false;
  }
}

onMounted(() => {
  countdown = setInterval(computeTime, 1000);
});
onUnmounted(() => {
  clearInterval(countdown);
});

async function onChange(value: boolean) {
  await toggleCode(value ? 'gen' : 'del');
}

async function renew() {
  const old = data.code;
  if ((await toggleCode('renew')) && data.code != old) {
    message.warn('原绑定已过期无法续期，已为您生成码');
  }
}

async function toggleCode(action: 'del' | 'gen' | 'renew') {
  data.loading = true;
  const res = await request('/management/device/toggleCode', {
    action,
  });
  data.loading = false;
  if (res) {
    if (res.code) {
      data.status = true;
      data.code = res.code;
      data.end = Date.now() + res.time;
      computeTime()
      return true;
    } else {
      data.status = false;
    }
  }
}

const windowTool = inject<WindowTool | false>(WindowTool, false);

function close() {
  if (windowTool) {
    windowTool.close(true);
  }
}
</script>

<template>
  <div style="height: 100%; display: flex; flex-direction: column">
    <div style="padding: 20px; flex-grow: 1; overflow: auto">
      <a-switch
        :checked="data.status"
        @change="onChange"
        :loading="data.loading"
        checked-children="开启"
        un-checked-children="关闭"
      />
      <template v-if="data.status">
        <div style="margin-top: 20px">
          <sc-btn
            text="重新生成"
            style="margin-right: 12px"
            :handler="() => toggleCode('gen')"
          />
          <sc-btn text="重置有效期" :handler="renew" />
        </div>
        <div style="margin-top: 20px">
          剩余时间：{{ formatTime(data.time) }}
        </div>
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px 0;
          "
        >
          <div
            style="
              text-align: center;
              font-size: 60px;
              background: rgba(29, 165, 122, 0.25);
              padding: 0 60px;
            "
          >
            {{ data.code }}
          </div>
        </div>
      </template>
    </div>
    <div class="form-btn-group">
      <sc-btn :handler="close" text="关闭" type="primary" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.form-btn-group {
  border-top: 1px solid $color-content-border;
  padding: $spacing-medium;
}
</style>
